<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Línea de tiempo: Caída de Tenochtitlán</h2>
    <a href="galerias/tenochtitlan/timeline/L1_1_F.png" target="_blank">
      <img src="galerias/tenochtitlan/timeline/L1_1_F.png" width="100%"/>
    </a>
    <p class="photo-description">Puedes hacer click derecho sobre la imagen para descargar la línea del tiempo en tamaño completo.</p>
  </div>
</template>

<script>
export default {
  name: "Sala1Timeline",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
